import { getApi } from '@BUP/services/Axios'

// Lightweight resource-view reporter for U4 (counselor dashboard metrics).
// Fire-and-forget: a failed report must never break the UX. The backend
// derives role and school scope from the authenticated enrollment, so the
// payload only carries what the view was.

export async function reportResourceView (resourceType, resourceId) {
  if (!resourceType || !resourceId) return false
  try {
    const client = await getApi('schools', { version: 5, authenticated: true })
    await client.post('/events/resource-view', {
      resourceType: String(resourceType),
      resourceId: String(resourceId)
    })
    return true
  } catch (error) {
    return false
  }
}
